import { useEffect, useState } from "react";

import {
  AlterarFormatoData,
  CalcularDiferencaDias,
} from "../../../components/Globais";
import { DatePicker, Row, Form, Modal } from "antd";

import type { Dayjs } from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useAdicionarPeriodo } from "../hooks/useAdicionarPeriodo";
import { useNavigate } from "react-router-dom";

export default function ModalAdicionar({
  isModalOpen,
  handleFechar,
  cotaId,
}: any) {
  const [form] = Form.useForm();

  const { RangePicker } = DatePicker;
  const dateFormat = "DD/MM/YYYY";
  // Estado inicial de dos dados Postagem que serão atualizados
  const [periodoData, setPeriodoData] = useState<any>({});

  // Função que armazena os dados alterados de Apartamento
  const periodoChange = (changedValues: Partial<any>, allValues: any) => {
    setPeriodoData((prevState: any) => ({
      ...prevState,
      ...allValues,
    }));
  };

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  const onRangeChangeMaisPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      let diferenca = CalcularDiferencaDias(
        AlterarFormatoData(dateStrings[1]),
        AlterarFormatoData(dateStrings[0])
      );
      if (diferenca > 7) {
        showError("O período deve ser menor ou igual a 7 dias.");
      } else {
        setPeriodoData((prevState: any) => ({
          ...prevState,
          checkIn: AlterarFormatoData(dateStrings[0]), // Check-in formatado
          checkOut: AlterarFormatoData(dateStrings[1]), // Check-out formatado
        }));
      }
    }
  };

  const { adicionar, isLoading, error, success, resetError } =
    useAdicionarPeriodo();

  const [errorDisplayed, setErrorDisplayed] = useState(false); // Estado para controlar se o erro já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isModalOpen) {
      if (success && !successDisplayed) {
        showSuccess(success);
        setSuccessDisplayed(true);

        setTimeout(() => {
          setSuccessDisplayed(false);
          navigate(0);
        }, 3000);
      }

      if (error && !errorDisplayed) {
        showError(error);
        setErrorDisplayed(true);

        setTimeout(() => {
          setErrorDisplayed(false);
          resetError(); // Reseta o erro no hook
        }, 3000);
      }
    } else {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    showSuccess,
    showError,
    errorDisplayed,
    successDisplayed,
    navigate,
    error,
    resetError, // Adicione a função resetError às dependências
  ]);

  return (
    <Modal
      open={isModalOpen}
      title="Adicionar período"
      okText="Adicionar"
      cancelText="Cancelar"
      onCancel={handleFechar}
      confirmLoading={isLoading}
      width={300}
      onOk={() => {
        adicionar(periodoData, cotaId);
      }}
    >
      <>{successContextHolder}</>
      <>{errorContextHolder}</>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changedValues, allValues) =>
          periodoChange(changedValues, allValues)
        }
      >
        <Row gutter={16}>
          <Form.Item
            name="periodo"
            label="Período"
            // {...{ wrapperCol: { span: 9, offset: 2 } }}
          >
            <RangePicker
              placeholder={["check-in", "check-out"]}
              format={dateFormat}
              size={"large"}
              onChange={onRangeChangeMaisPeriodo}
            />
          </Form.Item>
        </Row>
        <Row gutter={16}>
          <Form.Item
            name="dataEspecial"
            label="Data especial"
            style={{ width: 400 }}
            rules={[
              {
                message: "Caso a data seja especial insira aqui!",
              },
            ]}
          >
            <TextArea size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
        <Row gutter={16}>
          <Form.Item
            name="valor"
            label="Valor"
            style={{ width: 400 }}
            rules={[{ required: false, message: "Por favor insira um valor!" }]}
          >
            <TextArea size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
